import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import {LazyLoadImage} from "react-lazy-load-image-component";
import BannerImg from "../../images/referral-program/referral-partner.png";

function Referralpartners(props) {
    return (
        <div className="ref-partners tekrevol_dark_bg p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="ref-part-cont">
                            <h2>Sign Up Now & Earn As Much Money As Our Consistent Referral Partners</h2>
                            <p>Our App Development Referral Program Has An Incredible Amount of Incentives:</p>
                            <ul>
                                <li>Earn Up To 25%* In Commissions</li>
                                <li>Top Partners Can Earn Even More & Get Dedicated Support</li>
                                <li>Account Managers Guide You In Securing More Conversions</li>
                            </ul>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
                        <div className="ref-part-img">
                            <LazyLoadImage
                                src={BannerImg}
                                effect="blur" alt="latest-events" className="img-fluid"
                            />
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Referralpartners;